import React from 'react'
import Reports from './Reports'

const Dashboard = () => {
    return (
        <Reports />
    )
}

export default Dashboard
